<template>
  <v-card
    class="pr-2 d-flex flex-column justify-center"
    @click="onAjoutClick"
  >
    <div class="align-self-center py-1">
      <v-icon
        color="secondary"
        x-large
      >
        mdi-plus
      </v-icon>
    </div>
    <div class="align-self-center py-1">
      <v-card-title
        class="secondary--text text-h6 text-md-subtitle-1 font-weight-bold align-self-center"
      >
        Ajouter un témoignage
      </v-card-title>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'AjoutTemoignage',
  methods: {
    onAjoutClick () {
      this.$emit('ajout-temoignage')
    }
  }
}
</script>
